import React, { useEffect, useState } from 'react'
import { Button, Collapse, Table } from 'reactstrap'
import { Link, useNavigate, useNavigationType } from "react-router-dom";
import SubAdmins from "models/subadmins.modal";
import { helper } from "lib/helper";


const EditPermission = ({permissionslist}) => {
  const navigate = useNavigationType();
    const[people, setPeople]= useState(false);
  const[Activities, setActivities]= useState(false);
  const[Communication, setCommunication] =useState(false);
  const[finance, setfinance]= useState(false);
  const[useful, setuseful]=useState(false);
  const[enquiry, setenquiry]=useState(false)
  
 
console.log("mobile",permissionslist)
  
  const [isExpanded, setIsExpanded] = useState(true);
  const peopleclick = ()=>{
    setPeople(!people);
  }
  const Activitiesclick = ()=>{
    setActivities(!Activities);
  }
  const Communicationclick =()=>{
    setCommunication(!Communication)
  }
  const financeclick =()=>{
    setfinance(!finance)
  }
  const usefulclick =()=>{
    setuseful(!useful)
  }
  const enquiryclick =()=>{
    setenquiry(!enquiry)
  }
  useEffect(() => {
    console.log("gglsflslf",permissionslist)
    if (permissionslist && permissionslist.permissions) {
      if (permissionslist?.permissions?.includes("People")) {
        setPeople(true);
      }
      if (permissionslist?.permissions?.includes("Activities")) {
        setActivities(true);
      }
      if (permissionslist?.permissions?.includes("Communication")) {
        setCommunication(true);
      }
      if (permissionslist?.permissions?.includes("Finance Management")) {
        setfinance(true);
      }
      if (permissionslist?.permissions?.includes("Useful Corners")) {
        setuseful(true);
      }
      if (permissionslist?.permissions?.includes("Enquiry")) {
        setenquiry(true);
      }
    }
  }, [permissionslist]); 
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  // Effect to set initial selectedPermissions from permissionslist
  useEffect(() => {
    if (permissionslist?.permissions) {
      setSelectedPermissions(permissionslist.permissions);
    }
  }, [permissionslist]);

  const isChecked = (permissionName) => {
    return selectedPermissions.includes(permissionName);
  };

  const handleCheckboxChange = (permissionName) => {
    setSelectedPermissions((prev) => {
      if (prev.includes(permissionName)) {
        return prev.filter((perm) => perm !== permissionName); // Uncheck
      } else {
        return [...prev, permissionName]; // Check
      }
    });
  };
  const Editsubadmin = (event)=>{
    event.preventDefault();
    
    const form = new FormData(event.target)
    const allPermissions = form.getAll("permissions[]");

    const Tutors = allPermissions.includes("Tutors") ? "Tutors" : null;
    if(Tutors =="Tutors"){
      form.append("permissions[]","People")
    }
    const Parents = allPermissions.includes("Parents") ? "Parents" : null;
    if(Parents =="Parents"){
      form.append("permissions[]","People")
    }
    const EnquiryMgt = allPermissions.includes("Enquiry Mgt") ? "Enquiry Mgt" : null;
    if(EnquiryMgt =="Enquiry Mgt"){
      form.append("permissions[]","Activities")
    }
    const Classmgt = allPermissions.includes("Class mgt") ? "Class mgt" : null;
    if(Classmgt =="Class mgt"){
      form.append("permissions[]","Activities")
    }
    const Supportticket = allPermissions.includes("Support ticket") ? "Support ticket" : null;
    if(Supportticket =="Support ticket"){
      form.append("permissions[]","Activities")
    }
    const EHC = allPermissions.includes("EHC") ? "EHC" : null;
    if(EHC =="EHC"){
      form.append("permissions[]","Activities")
    }
    const Referl = allPermissions.includes("Referl") ? "Referl" : null;
    if(Referl =="Referl"){
      form.append("permissions[]","Activities")
    }
    const ShortlistTutors = allPermissions.includes("Shortlist Tutors") ? "Shortlist Tutors" : null;
    if(ShortlistTutors =="Shortlist Tutors"){
      form.append("permissions[]","Activities")
    }
    const TutorLinedup = allPermissions.includes("Tutor Lined-up") ? "Tutor Lined-up" : null;
    if(TutorLinedup =="Tutor Lined-up"){
      form.append("permissions[]","Activities")
    }
    const AllAttendence = allPermissions.includes("All Attendence") ? "All Attendence" : null;
    if(AllAttendence =="All Attendence"){
      form.append("permissions[]","Activities")
    }
    const CreditMapping = allPermissions.includes("Credit Mapping") ? "Credit Mapping" : null;
    if(CreditMapping =="Credit Mapping"){
      form.append("permissions[]","Activities")
    }
    const TutorPayroll = allPermissions.includes("Tutor's Payroll") ? "Tutor's Payroll" : null;
    if(TutorPayroll =="Tutor's Payroll"){
      form.append("permissions[]","Activities")
    }
    const NotificationNotice = allPermissions.includes("Notification / Notice") ? "Notification / Notice" : null;
    if(NotificationNotice =="Notification / Notice"){
      form.append("permissions[]","Communication")
    }
    const RaiseInvoice = allPermissions.includes("Raise Invoice") ? "Raise Invoice" : null;
    if(RaiseInvoice =="Raise Invoice"){
      form.append("permissions[]","Finance Management")
    }
    const DraftTutorSalary = allPermissions.includes("Draft Tutor Salary") ? "Draft Tutor Salary" : null;
    if(DraftTutorSalary =="Draft Tutor Salary"){
      form.append("permissions[]","Finance Management")
    }
    const AllTransaction = allPermissions.includes("All Transaction") ? "All Transaction" : null;
    if(AllTransaction =="All Transaction"){
      form.append("permissions[]","Finance Management")
    }
    const ClientBalance = allPermissions.includes("Client Balance") ? "Client Balance" : null;
    if(ClientBalance =="Client Balance"){
      form.append("permissions[]","Finance Management")
    }
    const QuestionsMgmt = allPermissions.includes("Questions Mgmt") ? "Questions Mgmt" : null;
    if(QuestionsMgmt =="Questions Mgmt"){
      form.append("permissions[]","Useful Corners")
    }
    const FAQs = allPermissions.includes("FAQs") ? "FAQs" : null;
    if(FAQs =="FAQs"){
      form.append("permissions[]","Useful Corners")
    }
    const ContactUs = allPermissions.includes("Contact Us") ? "Contact Us" : null;
    if(ContactUs == "Contact Us"){
      form.append("permissions[]","Useful Corners")
    }
    const Feedback = allPermissions.includes("Feedback") ? "Feedback" : null;
    if(Feedback == "Feedback"){
      form.append("permissions[]","Useful Corners")
    }
    const State = allPermissions.includes("State") ? "State" : null;
    if(State == "State"){
      form.append("permissions[]","Useful Corners")
    }
    const City = allPermissions.includes("City") ? "City" : null;
    if(City == "City"){
      form.append("permissions[]","Useful Corners")
    }
    const Level = allPermissions.includes("Level") ? "Level" : null;
    if(Level == "Level"){
      form.append("permissions[]","Useful Corners")
    }
    const Academic = allPermissions.includes("Academic") ? "Academic" : null;
    if(Academic == "Academic"){
      form.append("permissions[]","Useful Corners")
    }
    const Product = allPermissions.includes("Product") ? "Product" : null;
    if(Product == "Product"){
      form.append("permissions[]","Useful Corners")
    }
    const AllVideos = allPermissions.includes("All Videos") ? "All Videos" : null;
    if(AllVideos == "All Videos"){
      form.append("permissions[]","Useful Corners")
    }
    const NewEnq = allPermissions.includes("New Enq") ? "New Enq" : null;
    if(NewEnq == "New Enq"){
      form.append("permissions[]","Enquiry")
    }
    const QualifiedEnq = allPermissions.includes("Qualified Enq") ? "Qualified Enq" : null;
    if(QualifiedEnq == "Qualified Enq"){
      form.append("permissions[]","Enquiry")
    }
    const PendingEnq = allPermissions.includes("Pending Enq") ? "Pending Enq" : null;
    if(PendingEnq == "Pending Enq"){
      form.append("permissions[]","Enquiry")
    }
    const DisqualifiedEnq = allPermissions.includes("Disqualified Enq") ? "Disqualified Enq" : null;
    if(DisqualifiedEnq == "Disqualified Enq"){
      form.append("permissions[]","Enquiry")
    }
    const allPermissionArray = form.getAll("permissions[]");
   

    // Create a Set to remove duplicates and convert it back to an array
    const uniquePermissions = Array.from(new Set(allPermissionArray));

    console.log("without",uniquePermissions)
    const newform = new FormData()
    // If you want to update the form with unique values
    uniquePermissions.forEach(permission => {
        newform.append("permissions[]", permission);
    });
    const allPermissionArrayes = newform.getAll("permissions[]");
    console.log("lead",allPermissionArrayes)
    SubAdmins.addAdmin(permissionslist?.mobile, newform)
      .then((responce) => {
        helper.sweetalert.toast(responce.data.message, "success");
        
        navigate("/admin/user");
      })
      .catch((error) => {
        console.log("error", error);
      });
    
  }
  return (
    <div>
      <div
        className="box-container"
        style={{ border: "1px solid #f0f1f3", width: "100%", height: "100%" ,backgroundColor:"white"}}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            height: "50px",
            alignItems: "center",
          }}
        >
          <div style={{ marginLeft: "1.5rem", display: "flex", justifyContent:"space-between",width:"88%",fontWeight:"bold" }}>
            <span style={{display:"flex"}}> Permission For</span> <span style={{display:"flex"}}> Is Allowed</span>
          </div>
          {/*<div style={{ marginRight: "1rem" }}>
            {isExpanded ? (
                <i class="fa-solid fa-caret-down" onClick={toggleCollapse}></i>
           
            ) : (
             
              <i class="fa-solid fa-caret-up" onClick={toggleCollapse}></i>
            )}
          </div>*/}
        </div>

        <Collapse isOpen={isExpanded} style={{ padding: 0 }}>
          <form onSubmit={Editsubadmin}>
            <div
              style={{
                maxHeight: "250px",
                overflowY: "auto",
                position: "relative",
              }}
            >
              <Table className="table" responsive>
               { /*<thead className="thead-light">
                  <tr style={{ position: "sticky" }}>
                    <th>Permission Type</th>
                    <th style={tablehedingStyle}>Is Allowed</th>
                  </tr>
                </thead>*/}
                <tbody>
                <tr>
                    <td >Video</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Video"
                        type="checkbox"
                        checked={isChecked("Video")}
                        onChange={() => handleCheckboxChange("Video")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Test user</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Test user"
                        type="checkbox"
                        checked={isChecked("Test user")}
                        onChange={() => handleCheckboxChange("Test user")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Contact List</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Contact List"
                        type="checkbox"
                        checked={isChecked("Contact List")}
                        onChange={() => handleCheckboxChange("Contact List")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Banner</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Banner"
                        type="checkbox"
                        checked={isChecked("Banner")}
                        onChange={() => handleCheckboxChange("Banner")}
                        
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Blogs</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Blogs"
                        type="checkbox"
                        checked={isChecked("Blogs")}
                        onChange={() => handleCheckboxChange("Blogs")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Student Leader Board</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Student Leader Board"
                        type="checkbox"
                        checked={isChecked("Student Leader Board")}
                        onChange={() => handleCheckboxChange("Student Leader Board")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Tutor Leader Board</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Tutor Leader Board"
                        type="checkbox"
                        checked={isChecked("Tutor Leader Board")}
                        onChange={() => handleCheckboxChange("Tutor Leader Board")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Dashboard</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Dashboard"
                        type="checkbox"
                        checked={isChecked("Dashboard")}
                        onChange={() => handleCheckboxChange("Dashboard")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Report</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Report"
                        type="checkbox"
                        checked={isChecked("Report")}
                        onChange={() => handleCheckboxChange("Report")}
                      />
                    </td>
                  </tr>
                 <tr> <td><span style={{fontSize:"15px",fontWeight:"bold"}}>People</span> <span onClick={peopleclick}><i
                    className={`fa-solid fa-caret-${people ? "up" : "down"}`}
                    style={{
                      fontSize:"18px",
                      color: "blue",
                      cursor: "pointer",
                      marginLeft:"15px",
                    }}></i></span></td></tr>
                    {people && <>
                    <tr>
                      <td>Tutors</td>
                      <td>
                        <input
                          name="permissions[]"
                          value="Tutors"
                          type="checkbox"
                          checked={isChecked("Tutors")}
                          onChange={() => handleCheckboxChange("Tutors")}
                        />
                      </td>
                    </tr>
                    <tr>
                    <td>Parents</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Parents"
                        type="checkbox"
                        checked={isChecked("Parents")}
                        onChange={() => handleCheckboxChange("Parents")}
                      />
                    </td>
                  </tr> 
                  </>
                  }
                  <tr> <td><span style={{fontSize:"15px",fontWeight:"bold"}}>Activities</span> <span onClick={Activitiesclick}><i
                    className={`fa-solid fa-caret-${Activities ? "up" : "down"}`}
                    style={{
                      fontSize:"18px",
                      color: "blue",
                      cursor: "pointer",
                      marginLeft:"15px",
                    }}></i></span></td></tr>
                    {Activities && <>
                    <tr>
                      <td>Enquiry Mgt</td>
                      <td>
                        <input
                          name="permissions[]"
                          value="Enquiry Mgt"
                          type="checkbox"
                          checked={isChecked("Enquiry Mgt")}
                          onChange={() => handleCheckboxChange("Enquiry Mgt")}
                        />
                      </td>
                    </tr>
                    <tr>
                    <td>Class mgt</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Class mgt"
                        type="checkbox"
                        checked={isChecked("Class mgt")}
                        onChange={() => handleCheckboxChange("Class mgt")}
                      />
                    </td>
                  </tr> 
                  <tr>
                    <td>Support ticket</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Support ticket"
                        type="checkbox"
                        checked={isChecked("Support ticket")}
                        onChange={() => handleCheckboxChange("Support ticket")}
                      />
                    </td>
                  </tr> 
                  <tr>
                    <td>EHC</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="EHC"
                        type="checkbox"
                        checked={isChecked("EHC")}
                        onChange={() => handleCheckboxChange("EHC")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Referl</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Referl"
                        type="checkbox"
                        checked={isChecked("Referl")}
                        onChange={() => handleCheckboxChange("Referl")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Shortlist Tutors</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Shortlist Tutors"
                        type="checkbox"
                        checked={isChecked("Shortlist Tutors")}
                        onChange={() => handleCheckboxChange("Shortlist Tutors")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Tutor Lined-up</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Tutor Lined-up"
                        type="checkbox"
                        checked={isChecked("Tutor Lined-up")}
                        onChange={() => handleCheckboxChange("Tutor Lined-up")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>All Attendence</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="All Attendence"
                        type="checkbox"
                        checked={isChecked("All Attendence")}
                        onChange={() => handleCheckboxChange("All Attendence")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Credit Mapping</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Credit Mapping"
                        type="checkbox"
                        checked={isChecked("Credit Mapping")}
                        onChange={() => handleCheckboxChange("Credit Mapping")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Tutor's Payroll</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Tutor's Payroll"
                        type="checkbox"
                        checked={isChecked("Tutor's Payroll")}
                        onChange={() => handleCheckboxChange("Tutor's Payroll")}
                      />
                    </td>
                  </tr>
                  </>

                  }
                  <tr> <td><span style={{fontSize:"15px",fontWeight:"bold"}}>Communication</span> <span onClick={Communicationclick}><i
                    className={`fa-solid fa-caret-${Communication ? "up" : "down"}`}
                    style={{
                      fontSize:"18px",
                      color: "blue",
                      cursor: "pointer",
                      marginLeft:"15px",
                    }}></i></span></td></tr>
                    {Communication && <>
                    <tr>
                      <td>Notification / Notice</td>
                      <td>
                        <input
                          name="permissions[]"
                          value="Notification / Notice"
                          type="checkbox"
                          checked={isChecked("Notification / Notice")}
                          onChange={() => handleCheckboxChange("Notification / Notice")}
                        />
                      </td>
                    </tr>
                   
                  </>
                  }
                   <tr> <td><span style={{fontSize:"15px",fontWeight:"bold"}}>Finance Management</span> <span onClick={financeclick}><i
                    className={`fa-solid fa-caret-${finance ? "up" : "down"}`}
                    style={{
                      fontSize:"18px",
                      color: "blue",
                      cursor: "pointer",
                      marginLeft:"15px",
                    }}></i></span></td></tr>
                    {finance && <>
                    <tr>
                      <td>Raise Invoice</td>
                      <td>
                        <input
                          name="permissions[]"
                          value="Raise Invoice"
                          type="checkbox"
                          checked={isChecked("Raise Invoice")}
                          onChange={() => handleCheckboxChange("Raise Invoice")}
                        />
                      </td>
                    </tr>
                    <tr>
                    <td>Draft Tutor Salary</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Draft Tutor Salary"
                        type="checkbox"
                        checked={isChecked("Draft Tutor Salary")}
                        onChange={() => handleCheckboxChange("Draft Tutor Salary")}
                      />
                    </td>
                  </tr> 
                  <tr>
                    <td>All Transaction</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="All Transaction"
                        type="checkbox"
                        checked={isChecked("All Transaction")}
                        onChange={() => handleCheckboxChange("All Transaction")}
                      />
                    </td>
                  </tr> 
                  <tr>
                    <td>Client Balance</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Client Balance"
                        type="checkbox"
                        checked={isChecked("Client Balance")}
                        onChange={() => handleCheckboxChange("Client Balance")}
                      />
                    </td>
                  </tr> 
                  </>
                  }
                  <tr> <td><span style={{fontSize:"15px",fontWeight:"bold"}}>Useful Corners</span> <span onClick={usefulclick}><i
                    className={`fa-solid fa-caret-${useful ? "up" : "down"}`}
                    style={{
                      fontSize:"18px",
                      color: "blue",
                      cursor: "pointer",
                      marginLeft:"15px",
                    }}></i></span></td></tr>
                    {useful && <>
                    <tr>
                      <td>Questions Mgmt</td>
                      <td>
                        <input
                          name="permissions[]"
                          value="Questions Mgmt"
                          type="checkbox"
                          checked={isChecked("Questions Mgmt")}
                          onChange={() => handleCheckboxChange("Questions Mgmt")}
                        />
                      </td>
                    </tr>
                    <tr>
                    <td>FAQs</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="FAQs"
                        type="checkbox"
                        checked={isChecked("FAQs")}
                        onChange={() => handleCheckboxChange("FAQs")}
                      />
                    </td>
                  </tr> 
                  <tr>
                    <td>Contact Us</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Contact Us"
                        type="checkbox"
                        checked={isChecked("Contact Us")}
                        onChange={() => handleCheckboxChange("Contact Us")}
                      />
                    </td>
                  </tr> 
                  <tr>
                    <td>Feedback</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Feedback"
                        type="checkbox"
                        checked={isChecked("Feedback")}
                        onChange={() => handleCheckboxChange("Feedback")}
                      />
                    </td>
                  </tr> 
                  <tr>
                    <td>State</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="State"
                        type="checkbox"
                        checked={isChecked("State")}
                        onChange={() => handleCheckboxChange("State")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="City"
                        type="checkbox"
                        checked={isChecked("City")}
                        onChange={() => handleCheckboxChange("City")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Level</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Level"
                        type="checkbox"
                        checked={isChecked("Level")}
                        onChange={() => handleCheckboxChange("Level")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Academic</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Academic"
                        type="checkbox"
                        checked={isChecked("Academic")}
                        onChange={() => handleCheckboxChange("Academic")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Product</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Product"
                        type="checkbox"
                        checked={isChecked("Product")}
                        onChange={() => handleCheckboxChange("Product")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>All Videos</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="All Videos"
                        type="checkbox"
                        checked={isChecked("All Videos")}
                        onChange={() => handleCheckboxChange("All Videos")}
                      />
                    </td>
                  </tr>
                  </>
                  }
                  
                  <tr> <td><span style={{fontSize:"15px",fontWeight:"bold"}}>Enquiry</span> <span onClick={enquiryclick}><i
                    className={`fa-solid fa-caret-${enquiry ? "up" : "down"}`}
                    style={{
                      fontSize:"18px",
                      color: "blue",
                      cursor: "pointer",
                      marginLeft:"15px",
                    }}></i></span></td></tr>
                    {enquiry && <>
                    <tr>
                      <td>New Enq</td>
                      <td>
                        <input
                          name="permissions[]"
                          value="New Enq"
                          type="checkbox"
                          checked={isChecked("New Enq")}
                          onChange={() => handleCheckboxChange("New Enq")}
                        />
                      </td>
                    </tr>
                    <tr>
                    <td>Qualified Enq</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Qualified Enq"
                        type="checkbox"
                        checked={isChecked("Qualified Enq")}
                        onChange={() => handleCheckboxChange("Qualified Enq")}
                      />
                    </td>
                  </tr> 
                  <tr>
                    <td>Pending Enq</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Pending Enq"
                        type="checkbox"
                        checked={isChecked("Pending Enq")}
                        onChange={() => handleCheckboxChange("Pending Enq")}
                      />
                    </td>
                  </tr> 
                  <tr>
                    <td>Disqualified Enq</td>
                    <td>
                      <input
                        name="permissions[]"
                        value="Disqualified Enq"
                        type="checkbox"
                        checked={isChecked("Disqualified Enq")}
                        onChange={() => handleCheckboxChange("Disqualified Enq")}
                      />
                    </td>
                  </tr> 
                  </>
                  }
                </tbody>
              </Table>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
                marginBottom:"5px",
                padding:"5px"
              }}
            >
              <Button color="secondary" to="/admin/user" tag={Link}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                }}
              >
                Save
              </Button>
              {/* )} */}
            </div>
          </form>
        </Collapse>
      </div>
    </div>
  )
}

export default EditPermission
